module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Anote"
    }
  }, [_vm._v("A Note on Usages")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Familytree"
    }
  }, [_vm._v("Family Tree")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Maincharacters"
    }
  }, [_vm._v("Main Characters")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction"
    }
  }, [_vm._v("Introduction: Against the Stream")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Young Trotsky, 1879–1896")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 2")]), _vm._v(" Revolution, Love and Exile, 1897–1902")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 3")]), _vm._v(" Escape, Splits and Revolution, 1902–06")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 4")]), _vm._v(" The Vienna Years, 1907–13")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 5")]), _vm._v(" War and Internationalism, 1914–17")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 6")]), _vm._v(" Revolution and Civil War, 1917–19")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 7")]), _vm._v(" The Commissar in Power, 1920–23")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 8")]), _vm._v(" Fighting Against His Time, 1924–28")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 9")]), _vm._v(" Prophet Without a Home, 1929–36")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Chapter 10")]), _vm._v(" Love and Death in Mexico, 1937–40")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Legacy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography/Further Reading")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Platesection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate Section")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0